export const ENABLE_PROCESS_MESSAGE_STATS = false;
export class BusServiceBase {
    constructor() {
        /**
         * the id of the worker owning this instance. will be set on every outgoing message for tracing
         */
        this.workerId = "";
        this.initReceived = false;
        /**
         * connections given to modules in this worker
         */
        this.connections = new Map();
        this.askCallbacks = new Map();
        /**
         * store the worker id from a ask request, which comes from bus.
         */
        this.askWorkerIds = new Map();
    }
    isReady() {
        return this.initReceived;
    }
    getWorkerId() {
        return this.workerId;
    }
    hasAskData(askId) {
        return this.askCallbacks.has(askId);
    }
    popAskData(askId) {
        const data = this.askCallbacks.get(askId);
        if (data !== undefined) {
            this.askCallbacks.delete(askId);
        }
        return data;
    }
    popWorkerIdForAskId(askId) {
        const workerId = this.askWorkerIds.get(askId);
        if (workerId !== undefined) {
            this.askWorkerIds.delete(askId);
        }
        return workerId;
    }
}
